import React from "react";
import { Box, Chip, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SignalAntennaIcon } from "@ui/components/icons/SidebarIcons";
export const FreeRoamingBadge = ({ size = "small", iconOnly = false, }) => {
    var _a;
    const { t } = useTranslation(["common"]);
    const icon = (React.createElement(Box, { sx: { display: "flex" } },
        React.createElement(SignalAntennaIcon, { size: 14 })));
    return (React.createElement(Tooltip, { title: (_a = t("common:descriptions.freeRoamingNodeBadge")) !== null && _a !== void 0 ? _a : "" }, iconOnly ? (React.createElement(Chip, { icon: icon, size: size, variant: "soft", color: "info", "aria-label": t("common:grid.freeRoaming"), sx: {
            "& .MuiChip-label": { display: "none" },
            width: 28,
            "& .MuiChip-icon": { margin: 0 },
        } })) : (React.createElement(Chip, { icon: icon, label: t("common:grid.freeRoaming"), size: size, variant: "soft", color: "info" }))));
};
export default FreeRoamingBadge;
